import ObjectProxy from '@ember/object/proxy';
import BufferedProxyMixin from './mixin';
export default ObjectProxy.extend(BufferedProxyMixin);